
import _ from 'lodash';
export const handleChange = (event, validationMessage, setValidationMessage) => {
  const { id, value } = event.target;

  let statusError = 'is-invalid';

  statusError = value !== null && value !== '' ? 'is-valid' : 'is-invalid';
  setValidationMessage({
    ...validationMessage,
    [id]: { ...validationMessage[id], text: statusError }
  });
};

